document.addEventListener('DOMContentLoaded', function() {
	$('.hero-img-slider').slick({
		slidesToShow: 1,
		infinite: true,
		draggable: true,
		arrows: false,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 4000
	});
	$('.hero-img-slider-mobile').slick({
		slidesToShow: 1,
		infinite: true,
		draggable: true,
		arrows: false,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 4000
	});
	$('.categories-slider').slick({
		slidesToShow: 6,
		infinite: true,
		draggable: true,
		autoplay: true,
		autoplaySpeed: 1500,
		prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0914/9975/7874/files/left-arrow.svg?v=1745325279" alt="Left Arrow"></button>',
		nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0914/9975/7874/files/right-arrow.svg?v=1745325245" alt="Right Arrow"></button>',
		responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 5,
				}
			}, {
				breakpoint: 768,
				settings: {
					slidesToShow: 4,
				}
			}, {
				breakpoint: 576,
				settings: {
					slidesToShow: 3,
				}
			}
		]
	});

	$('.testimonial-slider').slick({
		slidesToShow: 3,
		dots: true,
		infinite: true,
		draggable: true,
		arrows: false,
		autoplay: true,
		speed: 800,
		autoplaySpeed: 2000,
		centerMode: true,
		centerPadding: '0px',
		responsive: [{
			breakpoint: 1200,
			settings: {
				slidesToShow: 2,
				centerMode: false,
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1.5,
				centerMode: false,
			}
		}, {
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
				centerMode: false,
			}
		}]
	});

	$('.testimonial-slider .slick-slide').on('click', function() {
		const index = $(this).data('slick-index');
		$('.testimonial-slider').slick('slickGoTo', index);
	});

	$(".navbar-toggler").on("click", function(e) {
		$(".navbar-collapse").toggleClass("show");
		$(".body-overlay").toggleClass("show");
		$("body").toggleClass("no-scroll");
		e.stopPropagation();
	});

	$("body").on("click", function() {
		$(".navbar-collapse").removeClass("show");
		$(".body-overlay").removeClass("show");
		$("body").removeClass("no-scroll");
	});

	$(".menu-close-btn").on("click", function() {
		$(".navbar-collapse").removeClass("show");
		$(".body-overlay").removeClass("show");
		$("body").removeClass("no-scroll");
	});

	$(".navbar-collapse").on("click", function(e) {
		e.stopPropagation();
	});

	$('.video-slider').slick({
		slidesToShow: 4,
		infinite: true,
		draggable: true,
		autoplay: true,
		autoplaySpeed: 2000,
		prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0914/9975/7874/files/Component_14.png?v=1746612437" alt="Left Arrow"></button>',
		nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0914/9975/7874/files/Component_13.png?v=1746612704" alt="Right Arrow"></button>',
		responsive: [
          {
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
			}
		},
          {
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
			}
		},
          {
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
			}
		}
        ]
	});

	$(window).on("scroll", function() {
		if ($(this).scrollTop() > 100) {
			$("header .top-header").addClass("sticky");
		} else {
			$("header .top-header").removeClass("sticky");
		}
	});

	$(".new-arrivals .card-box .card-btn .card-btn-2").on("click", function(e) {
		$(this).toggleClass("show");
		e.stopPropagation();
	});

	$(".new-arrivals .card-box .card-btn .card-btn-2 img").on("click", function() {
		$(this).toggleClass("fill");
	});

  ///////////////////////
   $(window).scroll(function () {
      var scrollPos = $(window).scrollTop();
  
      if (scrollPos >= 60) {
        $('.main-header').addClass('fixed-nav');
      } else {
        $('.main-header').removeClass('fixed-nav');
      }
  });
  
});